export default __webpack_public_path__ + "static/media/AW1.2c9b9e77.jpg";